// deps
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

// constants
import { USER_LOCALE_INTL_MESSAGES } from "@cloudspire/shared/constants/user";

type IProps = {
  locale: string;
};

const Locale: React.FunctionComponent<IProps> = (props) => {
  const { locale } = props;

  return (
    <Fragment>
      {USER_LOCALE_INTL_MESSAGES.byValue?.[locale]?.label ? (
        <FormattedMessage
          {...USER_LOCALE_INTL_MESSAGES.byValue[locale].label}
        />
      ) : (
        locale
      )}
    </Fragment>
  );
};

export default Locale;
